import { SET_MOVE_FLOATING_BUTTON } from 'Actions/types';

const INITIAL_STATE = {
  moveFloatingButton: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_MOVE_FLOATING_BUTTON:
      return { ...state, moveFloatingButton: action.payload };
    default:
      return { ...state };
  }
};
